import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const apiUrl = import.meta.env.VITE_APP_API;

const CartIcon = () => {
    const [cartCount, setCartCount] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchCartCount();
    }, []);

    const fetchCartCount = async () => {
        try {
            // You can replace this with your actual cart API endpoint
            // For now, I'll use a mock count or you can implement the actual API call
            const accessToken = JSON.parse(localStorage.getItem("faceAuthTokenData"))?.token?.access;
            
            if (accessToken) {
                // Uncomment this when you have the actual cart API
                // const response = await axios.get(`${apiUrl}/api/cart/count/`, {
                //     headers: { Authorization: `Bearer ${accessToken}` }
                // });
                // setCartCount(response.data.count || 0);
                
                // For now, using localStorage to store cart count
                const storedCount = localStorage.getItem('cartCount');
                setCartCount(storedCount ? parseInt(storedCount) : 0);
            } else {
                // For non-authenticated users, use localStorage
                const storedCount = localStorage.getItem('cartCount');
                setCartCount(storedCount ? parseInt(storedCount) : 0);
            }
        } catch (error) {
            console.error('Error fetching cart count:', error);
            // Fallback to localStorage
            const storedCount = localStorage.getItem('cartCount');
            setCartCount(storedCount ? parseInt(storedCount) : 0);
        } finally {
            setLoading(false);
        }
    };

    // Function to update cart count (can be called from other components)
    const updateCartCount = (count) => {
        setCartCount(count);
        localStorage.setItem('cartCount', count.toString());
    };

    // Expose the update function globally so other components can use it
    React.useEffect(() => {
        window.updateCartCount = updateCartCount;
        return () => {
            delete window.updateCartCount;
        };
    }, []);

    if (loading) {
        return null; // Don't show anything while loading
    }

    return (
        <div className="fixed bottom-6 left-6 z-50">
            <Link
                to="/cart"
                className="relative inline-block p-4 bg-blue-600 rounded-full shadow-lg hover:bg-blue-700 transition-colors duration-200 cursor-pointer"
            >
                {/* Shopping Cart Icon */}
                <svg
                    className="w-8 h-8 text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>
                </svg>

                {/* Notification Badge */}
                {cartCount > 0 && (
                    <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full h-6 w-6 flex items-center justify-center">
                        {cartCount > 99 ? '99+' : cartCount}
                    </div>
                )}
            </Link>
        </div>
    );
};

export default CartIcon; 